<template>
  <client-only>
    <div v-if="minisite && minisite.headerPath" id="minisite-header">
      <img alt="Header Image" :src="minisite.headerPath" />
    </div>
    <div v-else></div>
  </client-only>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MinisiteHeader',
  serverCacheKey() {
    return false
  },
  computed: {
    ...mapGetters({
      minisite: 'cart/minisite'
    })
  }
}
</script>
<style lang="scss">
#minisite-header {
  margin-bottom: 10px;
  padding: 0 15px;
  max-width: 1230px;
  margin: auto;
  background: #fff;
  img {
    width: 100%;
  }
}
</style>
